<template>
  <div class="overflow-hidden" :style="css">
    <Loading v-if="loading" />

    <v-container
      v-else
      class="py-10 py-sm-12 py-md-14 py-lg-16 mb-sm-6 mb-md-8 mb-lg-10"
    >
      <PagesTitle logoHeight="24px" :mod="mod">Vídeos</PagesTitle>

      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="8" class="mt-8 relative items">
          <hooper
            class="videos-hooper-slide"
            :wheelControl="false"
            infiniteScroll
          >
            <slide
              v-for="({ title, video }, keyItems) in items"
              :key="keyItems"
            >
              <div class="relative item">
                <img
                  :src="`https://img.youtube.com/vi/${getYoutubeCode(
                    video
                  )}/hqdefault.jpg`"
                  :alt="title"
                  class="d-block pa-2 item-img"
                />
                <div
                  class="d-flex align-center justify-center item-caption"
                  @click="openVideo(video)"
                >
                  <v-icon color="white" size="28"> fa fa-play </v-icon>
                </div>
              </div>
            </slide>
            <navigation v-if="!xs" slot="hooper-addons"></navigation>
            <pagination v-if="xs" slot="hooper-addons"></pagination>
          </hooper>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="play" content-class="modal" max-width="800px">
      <div class="relative">
        <v-btn
          @click="
            play = !play;
            videoId = null;
          "
          color="transparent"
          width="30px"
          height="30px"
          min-width="auto"
          depressed
          rounded
          class="white--text modal-close"
        >
          <v-icon>fa fa-times</v-icon>
        </v-btn>

        <v-responsive :aspect-ratio="1920 / 1080" width="100%">
          <iframe
            width="100%"
            height="100%"
            :src="
              'https://www.youtube.com/embed/' + videoId + '?autoplay=1&muted=1'
            "
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-responsive>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";
import { getYoutubeCode } from "../../utils/getYoutubeCode";
import { Hooper, Slide, Navigation, Pagination } from "hooper";
import "hooper/dist/hooper.css";

const _config = {
  mod: "pages-videos",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: true,
    items: [],
    play: false,
    videoId: null,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    css() {
      return {
        "--page-color": this.color,
      };
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  methods: {
    getYoutubeCode,
    openVideo(video) {
      this.videoId = getYoutubeCode(video);
      this.play = true;
    },
  },
  components: {
    Loading,
    PagesTitle,
    Hooper,
    Slide,
    Navigation,
    Pagination,
  },
};
</script>

<style lang="scss" scoped>
.items {
  &:before {
    background-image: url(/img/bg/videos.png);
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: contain;
    bottom: -30px;
    content: "";
    left: -30px;
    position: absolute;
    right: -30px;
    top: 0;
  }
  .videos-hooper-slide {
    .item {
      cursor: pointer;
      .item-img {
        aspect-ratio: 16 / 9;
        border-radius: 18px;
        object-fit: cover;
        -o-object-fit: cover;
        width: 100%;
      }
      .item-caption {
        background-color: rgba(0, 0, 0, 0.4);
        border: 8px solid #efefef;
        border-radius: 18px;
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.items {
  .videos-hooper-slide {
    height: 100%;
    ul,
    ol {
      padding-left: 0 !important;
    }
    .hooper-prev {
      align-items: center;
      background-color: #d9d9d9;
      border-radius: 50%;
      display: flex;
      height: 48px;
      justify-content: center;
      left: -70px;
      padding: 0;
      transition: all 0.1s linear;
      width: 48px;
      @media screen and (max-width: 960px) {
        left: -50px;
      }
      &:hover {
        background-color: var(--page-color);
      }
      svg {
        fill: white !important;
        width: 30px;
      }
    }
    .hooper-next {
      align-items: center;
      background-color: #d9d9d9;
      border-radius: 50%;
      display: flex;
      height: 48px;
      justify-content: center;
      padding: 0;
      right: -70px;
      transition: all 0.1s linear;
      width: 48px;
      @media screen and (max-width: 960px) {
        right: -50px;
      }
      &:hover {
        background-color: var(--page-color);
      }
      svg {
        fill: white !important;
        width: 30px;
      }
    }
    .hooper-pagination {
      bottom: -30px;
      .hooper-indicator {
        background-color: #cccccc;
        border-radius: 50%;
        height: 12px;
        &.is-active {
          background-color: var(--page-color) !important;
        }
      }
    }
  }
}
</style>
